import axios from "@/plugins/axios";

export default {
    getAll() {
        return axios.get('api/panel/tratamientos');
    },
    paginate(params) {
        return axios.get('api/panel/tratamientos/paginate', { params });
    },
    store(data) {
        return axios.post('api/panel/tratamientos', data);
    },
    update(id, data) {
        return axios.post(`api/panel/tratamientos/${id}`, data);
    },
    destroy(id,data) {
        return axios.delete(`api/panel/tratamientos/${id}`,data);
    },

}